<template>
  <div class="col-md-8 chart-card-col">
    <div class="chart-card">
      <div class="chart-card-header">
        <h5 class="chart-title">{{ statisticsItem[itemKey].data.name }}</h5>
      </div>
      <p class="chart-empty-state" v-if="statisticsItem[itemKey].data.data.length == 0">No data available</p>
      <BarChart v-else
        :chartData="{
          labels: statisticsItem[itemKey].data.labels,
          datasets: statisticsItem[itemKey].data.data
        }"
        :stacked="statisticsItem[itemKey].data.is_stacked"
        :styles="chartStyles"
      />
    </div>
  </div>
</template>

<script setup>
import BarChart from '@/components/atom/chart/barChart'

defineProps({
  statisticsItem: Object,
  page: Object,
  itemKey: String
})

const chartStyles = {
  position: 'relative',
  height: '300px'
}
</script>

<style scoped>
.chart-card {
  background-color: #ffffff;
  border: 1px solid #e8e9ec;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(34, 41, 47, 0.06);
  padding: 20px;
  height: 100%;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.chart-card-col {
  padding: 8px;
}

.chart-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(34, 41, 47, 0.12);
}

.chart-card-header {
  padding-bottom: 14px;
  margin-bottom: 16px;
  border-bottom: 1px solid #f0f1f4;
}

.chart-title {
  font-size: 14px;
  font-weight: 700;
  color: #2b2b2b;
  margin: 0;
  text-align: center;
}

.chart-empty-state {
  text-align: center;
  color: #8a8a8a;
  font-size: 13px;
  padding: 40px 0;
}
</style>
